import styled from 'styled-components';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { HINDI_LANG } from '../../../../../../modules/constants';

export const StyledShopPageSingleDateBoxDiv = styled.div<{ focused: boolean }>(
  ({ focused }) => `
    width: 100%;
    position: relative;
    margin-right: ${toRem(79)};

    @media ${theme.mediaQuery.allTablets} {
      min-width:${toRem(244)};
      margin-right: ${toRem(20)};
      width:auto;
    }
     @media ${theme.mediaQuery.smallerTablet} {
      min-width:${toRem(244)};
      margin-right: ${toRem(20)};
      &:nth-child(3) {
        min-width:${toRem(140)};
      }
    }
     @media ${theme.mediaQuery.allMobiles} {
      margin-right: ${toRem(20)};
      min-width:${toRem(145)};
       button {
      min-width:${toRem(192)};
    }
      width:100%;
      margin-left:1rem;
    }
    @media ${theme.mediaQuery.minDesktop} {
      &:hover{
        opacity: 0.6;
      }
    }
    &:nth-child(3) {
        padding-left: ${toRem(20)};
        border-left: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
        margin-right:0;
        @media ${theme.mediaQuery.allMobiles} {
          padding-left:0;
          border-left:0;
        }
        @media ${theme.mediaQuery.desktop} {
            padding-left: ${toRem(32)};
        }
        @media ${theme.mediaQuery.largeDesktop} {
            padding-left: ${toRem(48)};
        }
    }
    button {
        outline: none;
        cursor: pointer;
        background: transparent;
        padding: 0;
        width:100%;
        border: none;
        .search-page-date-text  {
            @media ${theme.mediaQuery.allTablets} {
              font-size:${toRem(16)};
            }
          }
        @media ${theme.mediaQuery.allMobiles} {
          .single-flex-icon {
            &::before {
            color:${theme.color['light-orange-2']} !important;
            padding-right:${toRem(8.58)};
            }
            letter-spacing: ${toRem(1.3)};
          }
          padding-bottom: ${toRem(13)};
          opacity: ${focused ? '1' : '0.8'};
          border-bottom: ${toRem(1)} solid ${theme.color.white};
          &:after {
              content: "";
              border-bottom:${toRem(5)} solid transparent;
              width: 100%;
              position: absolute;
              right: 0;
              bottom: 0;
            }
          .t-label-xs {
            color:${theme.color.white};
          }
        }
        &:first-child {
          display: flex;
          flex-direction: column;
          white-space: nowrap;
          text-align: left;
          text-overflow: ellipsis;
          overflow: hidden;
          width: 100%;
            span {
              &:first-child {
                  padding-bottom: ${toRem(6)};
                  text-transform: uppercase;
                  white-space: nowrap;
                  text-align: left;
                  text-overflow: ellipsis;
                  overflow:hidden;
                  max-width:100%;
                  @media ${theme.mediaQuery.allTablets} {
                    max-width: ${toRem(252)};
                    padding-bottom: 0;
                }
                  @media ${theme.mediaQuery.desktop} {
                      padding-bottom: ${toRem(4)};
                      &:is(${HINDI_LANG}) {
                      padding-top: ${toRem(4)};
                      }
                  }
                }
            }
        }
        &:nth-child(3){
            font-size: ${toRem(24)};
            line-height: ${toRem(20)};
            position: absolute;
            bottom: ${toRem(19)};
            right: 0;
            padding: 0;
            ::before {
                color: ${theme.color['base-10']};
            }
        }
    }
`
);
